import { productService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    product: {}

}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, product) {
        state.status       = 'success'
        state.product       = product
    },
    fail(state) {
        state.status       = 'fail'
    },
}

const getters = {
    status: ({status}) => status,
    product: ({product}) => product
}

const actions = {
    find({commit}, hashid) {
        commit('loading')
        return productService.find(hashid).then(response => {
            commit('success', response.data.data)
        })
    },
    publicAccess({commit}, param) {
        commit('loading')
        return productService.publicAccess(param.store, param.hashid).then(response => {
            commit('success', response.data.data)
        })
    }
}
export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}